import { styled } from '@linaria/react';
import { breakpoints, layout, space } from '../../theme/tokens';

export const HeadingArea = styled.div`
  padding: 0 0 ${space['space-1000']};

  & h1 {
    max-width: 12.5em;
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding-top: ${space['space-500']};
  }

  @media (min-width: ${breakpoints.desktop}) {
    padding-right: ${space['space-1200']};
    padding-left: ${space['space-1200']};
  }
`;

export const GridArea = styled.div`
  @media (min-width: ${breakpoints.desktop}) {
    padding: 0
      clamp(
        0px,
        calc((100vw - ${breakpoints.desktop}) * 0.6),
        calc(${space['space-2000']} + ${space['space-1200']})
      );
  }
`;
